var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('welcome'),_vm._l((_vm.items),function(item){return _c('itemServices',{key:item.title,attrs:{"data":item,"id":item.id}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }